"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M20 5.778v5.858L17.333 8.96l-3.555 3.564-3.556-3.555-3.555 3.555L4 9.85V5.778C4 4.8 4.8 4 5.778 4h12.444C19.2 4 20 4.8 20 5.778zm-2.667 5.706L20 14.16v4.062C20 19.2 19.2 20 18.222 20H5.778C4.8 20 4 19.2 4 18.222v-5.849l2.667 2.658 3.555-3.555 3.556 3.555 3.555-3.547z" }), "NoImage");
//# sourceMappingURL=NoImage.js.map